import { v4 } from 'uuid';

export const getCurrentYearStart = () => {
  const currentYear = new Date().getFullYear();
  return getAsDate(new Date(currentYear, 0, 1));
};

export const getAsDate = dateString => {
  const options = {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour12: false,
  };
  return new Intl.DateTimeFormat('fr-CA', options)
    .format(new Date(dateString))
    .replace(/\//g, '-');
};

export const cases = (num, unitary, few, multiple) => {
  if (num % 10 === 1 && num % 100 !== 11) return unitary;

  if (num % 10 > 1 && num % 10 < 5 && (num % 100 < 11 || num % 100 > 15))
    return few;

  return multiple;
};

export const uuid = v4;

export const roundTo = (num, decimals) => {
  const factor = Math.pow(10, decimals);
  return Math.round(num * factor) / factor;
};

export const openPdfInNewTab = pdfData => {
  const byteCharacters = atob(pdfData);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/pdf' });
  const fileURL = URL.createObjectURL(blob);
  //Open the URL on new Window
  window.open(fileURL);
};

export const arrayToObject = (array, callback) => {
  return array.reduce((acc, item) => {
    const { key, value } = callback(item);
    acc[key] = value;
    return acc;
  }, {});
};
